export default "__VITE_ASSET__8c12aeb5__"